import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import { ELEMENT_TYPES } from '../../types/hubEnums';

const OPTION_CARD_STYLES =
  'mb-3 block w-full shadow-md pointer-cursor rounded-xl border border-grey-200 bg-white p-5 text-left hover:ring focus:ring group';

export const OptionCard = ({
  onClickHandler,
  linkTo,
  openInNewTab,
  children,
  className,
  disabled,
  type,
  capturePosthogEvent,
}) => {
  const classes = classNames(
    OPTION_CARD_STYLES,
    className,
    { 'cursor-not-allowed': disabled },
    { 'option-card': !disabled }
  );
  if (type === ELEMENT_TYPES.ANCHOR) {
    return (
      <a href={linkTo} target="_blank" rel="noreferrer" className={classes}>
        {children}
      </a>
    );
  }

  if (linkTo && !disabled) {
    return (
      <Link to={linkTo} className={classes} target={openInNewTab ? '_blank' : undefined} onClick={capturePosthogEvent}>
        {children}
      </Link>
    );
  }

  return (
    <button type="button" onClick={onClickHandler} className={classes} disabled={disabled}>
      {children}
    </button>
  );
};

export const OptionCardContent = ({ children, disabled }) =>
  disabled ? (
    <span className="text-base font-semibold !leading-[28px] text-grey-4 md:text-lg">{children}</span>
  ) : (
    <span className="text-base font-semibold !leading-[28px] text-grey-600 hover:text-grey-500 md:text-lg">
      {children}
    </span>
  );

OptionCardContent.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
};

OptionCardContent.defaultProps = {
  disabled: false,
};

OptionCard.propTypes = {
  onClickHandler: PropTypes.func,
  linkTo: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  openInNewTab: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  capturePosthogEvent: PropTypes.func,
};

OptionCard.defaultProps = {
  onClickHandler: () => {},
  linkTo: null,
  openInNewTab: false,
  className: '',
  disabled: false,
  type: ELEMENT_TYPES.DEFAULT,
  capturePosthogEvent: undefined,
};
